import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GoogleAnalyticsService } from '../google-analytics.service';
import { THEMATIC_TAG_COUNT_PLACEHOLDER } from '../portal-categories';

@Component({
    selector: 'app-portal-card',
    templateUrl: './portal-card.component.html',
    styleUrls: ['./portal-card.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PortalCardComponent {
  @Input() title: string;
  @Input() entriesCount: string;
  @Input() description: string;
  @Input() accentColor: string;
  @Input() categorySlug: string;

  // Exposed to the template so it can hide the "X entries" line entirely while the live
  // thematic_tags count is still loading/unavailable, instead of showing the placeholder
  // text (AFPDBE-1418 — the live fetch can take longer than usual, and "-- entries" reads
  // like a broken/stuck count rather than a loading state).
  public readonly entriesCountPlaceholder = THEMATIC_TAG_COUNT_PLACEHOLDER;

  constructor(public gaService: GoogleAnalyticsService) {}
}
